import * as React from 'react';
import * as style from './NewbuildingReviewsTeaser.css';
import { Layout } from '../Layout';

export interface INewbuildingReviewsTeaserProps {
  reviews: React.ReactElement<unknown>;
}

export const NewbuildingReviewsTeaser: React.FC<INewbuildingReviewsTeaserProps> = ({ reviews }) => {
  return (
    <div className={style['reviews']}>
      <Layout>
        <div data-nav-tab="reviews/Отзывы и вопросы" id="reviews" className={style['nav_container']}>
          {reviews}
        </div>
      </Layout>
    </div>
  );
};
